// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"ce22859c","957":"31d6cfe0"}[chunkId] + ".chunk.css";
};